// extracted by mini-css-extract-plugin
export default {"dragHandle":"SortableShopCard_dragHandle__1jC6w"};